import FileUploader, { FileType } from '@dgshahr/ui-kit/Form/FileUploader'
import {
  IDocumentsFormValues,
  IUploaderProps,
  TUploadedFile
} from '@/types/uploader'
import { useDocumentUploader } from '@/hooks/useDocumentUploader'
import { Alert } from '@dgshahr/ui-kit'

const BusinessLicense = ({ formik, corrections }: IUploaderProps) => {
  const { values } = formik
  const { handleUpload, handleDelete } = useDocumentUploader(formik)

  const fieldName = 'BUSINESS_LICENSE'

  const handleBusinessLicenseChange = (file: File | undefined) =>
    file && handleUpload(fieldName, file)

  const handleDeleteFile = (
    fieldName: keyof IDocumentsFormValues,
    e: TUploadedFile
  ): void => {
    handleDelete(fieldName, e)
  }

  return (
    <div className="flex flex-col gap-8">
      {corrections?.[fieldName] && (
        <div className="flex flex-col gap-4">
          <Alert
            size="small"
            title="اصلاحیه‌"
            variant="error"
            text={corrections[fieldName].comment}
          />
        </div>
      )}
      <label
        htmlFor="business-license"
        className="font-p2-medium text-gray-500"
      >
        تصویر جواز یا پروانه کسب را به گونه‌ای که اطلاعات آن واضح و مشخص باشد،
        بارگذاری کنید.
      </label>

      <FileUploader
        className="w-fit"
        fileInputProps={{
          id: 'business-license',
          className: 'ss02',
          description: 'فرمت‌های قابل قبول PNG , SVG یا PDF\nحداکثر حجم تا 5Mb',
          helperProps: {
            hintMessage: ''
          },
          title: 'تصاویر جواز کسب یا اینماد',
          accept:
            'image/png, image/jpeg, image/jpg, image/PNG, image/JPEG, image/JPG , application/pdf'
        }}
        mode="single"
        files={values?.[fieldName][0] as FileType}
        onChange={handleBusinessLicenseChange}
        previewProps={{
          leftButton: {
            onClick: (e) => handleDeleteFile(fieldName, e as TUploadedFile)
          },
          rightButton: false
        }}
      />
    </div>
  )
}

export default BusinessLicense
